module.exports = __webpack_public_path__ + "media/customizations/kalaiola/logo-a9558f124793a3eb6fcc88e904c98c09.png";